var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box"},[_c('img',{staticClass:"bg-img",attrs:{"src":"https://h5.sx2b2c.com/images/common/404.jpg","alt":""}})])
}]

export { render, staticRenderFns }